module.exports = __webpack_public_path__ + "static/media/7. RojoCadena1, Superficie sólida, 91 x 20 x 16 cm, 2020 copy.ea52b8d2.png";